/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Anna_QuoteInputs */

const en_marketing_app_anna_quote = /** @type {(inputs: Marketing_App_Anna_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I'm really picky about AI voices, but this one was amazing! Even at 1.5x speed, it was engaging to listen to. It's a game changer to be able to listen while walking!`)
};

const es_marketing_app_anna_quote = /** @type {(inputs: Marketing_App_Anna_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soy muy exigente con las voces de IA, ¡pero esta fue increíble! Incluso a velocidad 1.5x, era atractiva para escuchar. ¡Es un cambio total poder escuchar mientras caminas!`)
};

/**
* | output |
* | --- |
* | "I'm really picky about AI voices, but this one was amazing! Even at 1.5x speed, it was engaging to listen to. It's a game changer to be able to listen while ..." |
*
* @param {Marketing_App_Anna_QuoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_anna_quote = /** @type {((inputs?: Marketing_App_Anna_QuoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Anna_QuoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_anna_quote(inputs)
	return en_marketing_app_anna_quote(inputs)
});